export var APIKeysSortField = /*#__PURE__*/ function(APIKeysSortField) {
    APIKeysSortField["Name"] = "name";
    APIKeysSortField["Id"] = "id";
    APIKeysSortField["CreatedOn"] = "created";
    APIKeysSortField["UpdatedOn"] = "updated";
    return APIKeysSortField;
}({});
export const apiKeysHeaderItems = [
    {
        id: "name",
        value: 'Name'
    },
    {
        id: "id",
        value: 'Value'
    },
    {
        id: "created",
        value: 'Created'
    },
    {
        id: "updated",
        value: 'Updated'
    }
];
export const apiKeysColumnDefs = [
    {
        width: 300,
        sortable: true,
        bi: {
            name: 'sort_api_keys_by_name'
        }
    },
    {
        width: 240,
        sortable: false
    },
    {
        width: 240,
        sortable: true,
        bi: {
            name: 'sort_api_keys_by_created'
        }
    },
    {
        width: 240,
        sortable: true,
        bi: {
            name: 'sort_api_keys_by_updated'
        }
    }
];
export const formatAPIKeyValue = (keyId)=>{
    const lastFour = keyId.slice(-4);
    return "api-key-********".concat(lastFour);
};
